module.exports = __webpack_public_path__ + "media/images/fr_ca/chart_big-88f31751edc936a2623c5d90bd7b8bbf.png";